module.exports = {"id":"s6-q2","text":"Do you have access to a desktop or laptop WITHOUT internet access?","multiselect":false,"options":[{"id":"s6-q2-a1","text":"Yes","next":"s6-q1a","capability":2,"access":1,"focusarea":[0,0,0,0,2]},{"id":"s6-q2-a2","text":"No","next":"s6-q3","capability":-4,"access":-3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s6-q2.json
// module id = 930
// module chunks = 32